import { useFormats } from "@portal/hooks/use-formats";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { amountFormats } from "@sinecycle/growcomponents";
import { useAtomValue } from "jotai";
import { Statistic } from "../Statistic/AntStatistic";
import { ToolTip } from "../ToolTip/AntTooltip";
import { AmountProps } from "./types";

function Amount(props: AmountProps) {
  const baseCurrency =
    useAtomValue(userConfigAtom).user_details?.customer.currency;
  const amount = Number(props.amount);
  const { locale } = useFormats();
  const formatOptions = props.formatOptions ?? {};
  const options = {
    currency: props.currency ?? baseCurrency ?? "USD",
    locale: props.locale ?? locale,
  };

  const formattedAmount = isNaN(amount)
    ? "-"
    : amountFormats.currency(amount, options, formatOptions);

  return (
    <ToolTip
      title={
        props.showTooltip ? amountFormats.currency(amount, options) : undefined
      }
    >
      <Statistic
        valueStyle={{ fontSize: "var(--fs-14)", ...props.style }}
        className={props.className}
        value={formattedAmount}
      />
    </ToolTip>
  );
}

export { Amount };
